// History subsection form field enum
export enum HistoryFormField {
  HISTORY_FUNCTIONAL_LIMITATIONS = 'medicalBackground/history/functionalLimitations',
  HISTORY_ACTIVITIES_PERMITTED = 'medicalBackground/history/activitiesPermitted',
  HISTORY_MEDICAL_HISTORY = 'medicalBackground/history/medicalHistory',
  HISTORY_SURGICAL_HISTORY = 'medicalBackground/history/surgicalHistory'
}
